import React, { memo } from 'react';
import { CardTitle } from 'reactstrap';
import { WidgetProps } from '../types';
import { SectionTitleWidgetConfigData } from './SectionTitleWidgetConfig';

export const SectionTitleWidget = memo((props: WidgetProps<string, SectionTitleWidgetConfigData>) => {
  const { settings, config } = props;

  return (
    <div className="d-flex flex-column justify-content-end mb-2">
      <CardTitle style={{ fontSize: 25 }}>{settings.title || 'Section Title'}</CardTitle>
      <span className="text-muted text-truncate">{settings.description}</span>
    </div>
  );
});
